import React from 'react'
import { Route, Routes } from 'react-router-dom'
import SimpleSpinner from '../../components/Common/SimpleSpinner'

const Legal = React.lazy(() => import('./LegalOverview'))
const Policy = React.lazy(() => import('./Policy'))
const Piracy = React.lazy(() => import('./Piracy'))
const Cookies = React.lazy(() => import('./Cookies'))
const CookieSettings = React.lazy(() => import('./CookieSettingsLayout'))
const Privacy = React.lazy(() => import('./Privacy'))
const UserTerms = React.lazy(() => import('./UserTerms'))
const StreamingTerms = React.lazy(() => import('./StreamingTerms'))
const MGMembership = React.lazy(() => import('./MGMembership'))
const CSMembershipDomestic = React.lazy(() => import('./CSMembershipDomestic'))
const CSMembershipInternational = React.lazy(() => import('./CSMembershipInternational'))
const Error404 = React.lazy(() => import('../Error404'))

const LegalRoutes = () => {
  return (
    <React.Suspense fallback={<SimpleSpinner />}>
      <Routes>
        <Route path='/' element={<Legal />} />
        <Route path='/policy' element={<Policy />} />
        <Route path='/piracy' element={<Piracy />} />
        <Route path='/cookies' element={<Cookies />} />
        <Route path='/cookie-settings' element={<CookieSettings />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms' element={<UserTerms />} />
        <Route path='/streaming-terms' element={<StreamingTerms />} />
        <Route path='/mg-membership-terms' element={<MGMembership />} />
        <Route path='/cs-membership-domestic-terms' element={<CSMembershipDomestic />} />
        <Route path='/cs-membership-international-terms' element={<CSMembershipInternational />} />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </React.Suspense>
  )
}

export default LegalRoutes
